<script>
export default {
  data () {
    return {
      graphOptions: {
        segmentShowStroke: false,
        tooltips: {
          mode: 'label'
        },
        scales: {
          yAxes: [{
            gridLines: {
              zeroLineWidth: 2,
              lineWidth: 2
            },
            scaleLabel: {
              display: true,
              labelString: this.$t('leads.hearing_test.label_intensity'),
            },
            ticks: {
              callback: function (value, index, values) {
                return Math.abs(value) + ' dB'
              },
              min: -120,
              max: 0,
              stepSize: 20,
              fontFamily: "'PT Sans', sans-serif",
              fontSize: 14,
              padding: 5,
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.$t('leads.hearing_test.label_frequency')
            },
            gridLines: {
              display: false,
            },
            ticks: {
              callback: function (value, index, values) {
                return value + ' Hz'
              },
              fontFamily: "'PT Sans', sans-serif",
              fontSize: 14
            }
          }]
        }
      }
    }
  }
}
</script>